import * as modelsGet from "../models/get";
import { getDisplayTypes } from "../api/displayTypes";

var displayTypes: modelsGet.IDisplayType[];

/**
 * Gibt alle Anzeigearten zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getDisplayTypesAsync(reload: boolean = false): Promise<modelsGet.IDisplayType[]>
{
    if (displayTypes == null || reload)
    {
        displayTypes = await getDisplayTypes();
    }

    return displayTypes;
}